import type { AiTaskTarget } from "@workspace/api-client-react";

const encodedTask = (taskId: string) => encodeURIComponent(taskId);
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isAiTaskId(value: string | null | undefined): value is string {
  return typeof value === "string" && UUID_PATTERN.test(value);
}

/** Build a refresh-safe route from the persisted discriminated target. */
export function aiTaskTargetPath(target: AiTaskTarget | null, taskId: string): string {
  if (!target) return `/ai-results/${encodedTask(taskId)}`;
  switch (target.type) {
    case "analysis":
      return `/analyses/${target.analysisId}?aiTask=${encodedTask(taskId)}`;
    case "resume-career":
      return `/ai-results/${encodedTask(taskId)}`;
    case "resume-upload":
      return `/resumes/${target.resumeId}?aiTask=${encodedTask(taskId)}`;
    case "interview":
      return `/interviews/${target.interviewId}?aiTask=${encodedTask(taskId)}`;
    case "resume-spellcheck":
    case "cover-letter":
      return `/ai-results/${encodedTask(taskId)}`;
    case "companies":
      return `/companies?aiTask=${encodedTask(taskId)}`;
    case "company-draft":
      return `/companies/new?aiTask=${encodedTask(taskId)}`;
    case "company":
      return `/companies/${target.companyId}?aiTask=${encodedTask(taskId)}`;
  }
  return `/ai-results/${encodedTask(taskId)}`;
}

export function aiTaskIdFromSearch(search: string): string | null {
  const value = new URLSearchParams(search).get("aiTask")?.trim();
  return isAiTaskId(value) ? value : null;
}
